import TopPage from './homepage/TopPage';
import SignIn from './common/SignIn/SignIn';
import ChowaApp from './clients/chowa/ChowaApp';
import PrivateRoute from './common/components/PrivateRoute';

const routes = [
  {
    path: '/',
    element: <TopPage />,
    title: 'ホーム'
  },
  {
    path: '/signin',
    element: <SignIn />,
    title: 'サインイン'
  },
  {
    path: '/chowa/*',
    element: (
      <PrivateRoute authType="chowa">
        <ChowaApp />
      </PrivateRoute>
    ),
    title: 'Chowa Dashboard'
  }
];

export default routes;
